import React, { useState, useEffect, useContext } from "react";
import { RiLoader4Line } from "react-icons/ri";
import { FilterContext } from "../../context/Filter";
import { fetchData } from "./Arnkpi";
import ArnModal from "./arnmodel";
import Arntable from "./arntable";
import parimg from "../../assets/images/parent_arn_icon.png";

const searchTypeMap = {
    "Account Name": "acc_name",
    "ARN Number": "arn_no",
    "Chassis Number": "Chassis_number",
    "Vehicle Registration Number": "Vehicle_Registration_Number",
};

const ArnSearch = () => {
    const [selectedValue, setSelectedValue] = useState("");
    const [placeholder, setPlaceholder] = useState("Please select search type");
    const [isDisabled, setIsDisabled] = useState(true);
    const [value, setValue] = useState(""); // input text
    const [arnValue, setIsArn] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
    const [id, setId] = useState("");
    const [dealershiplastpurchase, setDealershiplastpurchase] = useState("");
    const [purchasedate, setPurchasedate] = useState("");
    const [kacodeparent, setKacodeparent] = useState("");
    const [purchasequantity, setPurchasequantity] = useState("");
    const [accountName, setAccountNameState] = useState("");
    const { open } = useContext(FilterContext); // true if sidebar is open


    const { setSuperArn, setAccountName, setid, setChildArn, isOpen, superArn } =
        useContext(FilterContext);
    const handlereset = () => {
        // console.log("reset button")
        setSelectedValue("")
        setDealershiplastpurchase("")
        setPurchasedate("")
        setPurchasequantity("")
        setKacodeparent("")
        setDealershiplastpurchase("")
        setSuperArn("")

        setAccountNameState("")
        setPlaceholder("")
        setValue("")
        setSearchResults("")
        setId("")
        setIsArn("")
        setAccountNameState("")
        setSuperArn("")


    }

    const options = [
        {
            label: "Account Name",
            value: "Account Name",
            placeholder: "Enter account name",
        },
        { label: "ARN Number", value: "ARN Number", placeholder: "Enter ARN number" },
        {
            label: "Vehicle Registration Number",
            value: "Vehicle Registration Number",
            placeholder: "Enter registration number",
        },
        {
            label: "Chassis Number",
            value: "Chassis Number",
            placeholder: "Enter chassis number",
        },
    ];

    useEffect(() => {
        if (!value || !selectedValue) {
            setSearchResults([]);
            setIsDropdownOpen(false);
            return;
        }

        const delayDebounce = setTimeout(async () => {
            setIsLoading(true);
            try {
                const results = await fetchData({
                    search_type: searchTypeMap[selectedValue],
                    inputValue: value.trim().replace(/\s+/g, ' ').toLowerCase(),

                });

                let safeResults = [];
                safeResults = results;

                setSearchResults(safeResults);
                setIsDropdownOpen(true);
            } catch (err) {
                console.error("API error:", err);
                setSearchResults([]);
                setIsDropdownOpen(false);
            } finally {
                setIsLoading(false);
            }
        }, 400);

        return () => clearTimeout(delayDebounce);
    }, [value, selectedValue]);

    const handleDropdownChange = (e) => {
        const selectedOption = options.find((opt) => opt.value === e.target.value);
        setSelectedValue(selectedOption?.value || "");
        setPlaceholder(selectedOption?.placeholder || "Please select search type");
        setIsDisabled(!selectedOption);
        setValue("");
        setIsArn("");
        setSearchResults([]);
        setIsDropdownOpen(false);
    };

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    // this is how using handlechange function, we are hitting setting value gain and again everytime delaydebounce hits
    const handleSuggestionClick = (result) => {
        if (!result) return;

        if (selectedValue === "Account Name") {
            setValue(result.account_name);
            setAccountName(result.account_name);
            setAccountNameState(result.account_name);
            setIsArn(result.arn_no || "");
            setId(result.id || "");
            setKacodeparent(result.ka_code_parent || "");
            setPurchasequantity(result.purchase_quantity || "");
            setPurchasedate(result.purchase_date || "");
            setDealershiplastpurchase(result.dealership_last_purchase || "");
        }

        if (selectedValue === "ARN Number") {
            setValue(result.arn_no);
            setAccountName(result.account_name || "");
            setAccountNameState(result.account_name || "");
            setIsArn(result.arn_no);
            setSuperArn(result.arn_no);

            setId(result.id || "");
            setKacodeparent(result.ka_code_parent || "");
            setPurchasequantity(result.purchase_quantity || "");
            setPurchasedate(result.purchase_date || "");
            setDealershiplastpurchase(result.dealership_last_purchase || "");
        }

        if (selectedValue === "Vehicle Registration Number") {
            setValue(result.Vehicle_Registration_Number);
            setAccountName(result.account_name || "");
            setAccountNameState(result.account_name || "");
            setIsArn(result.arn_no || "");
            setSuperArn(result.arn_no || "");

            setId(result.id || "");
            setKacodeparent(result.ka_code_parent || "");
            setPurchasequantity(result.purchase_quantity || "");
            setPurchasedate(result.purchase_date || "");
            setDealershiplastpurchase(result.dealership_last_purchase || "");
        }

        if (selectedValue === "Chassis Number") {
            setValue(result.Chassis_number);
            setAccountName(result.account_name || "");
            setAccountNameState(result.account_name || "");
            setIsArn(result.arn_no || "");
            setSuperArn(result.arn_no || "");

            setId(result.id || "");
            setKacodeparent(result.ka_code_parent || "");
            setPurchasequantity(result.purchase_quantity || "");
            setPurchasedate(result.purchase_date || "");
            setDealershiplastpurchase(result.dealership_last_purchase || "");
        }

        setChildArn("");
        setIsDropdownOpen(false);
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <>
            {isOpen && (
                <div className="p-3 mt-2 mx-2 bg-gray-100 rounded-md shadow-md relative">
                    <div className="flex flex-wrap gap-4 items-center">
                        {/* 🔹 First Dropdown */}
                        <div className={`flex-1 ${open ? 'max-w-56' : 'min-w-[200px]'}`}>
                            <select
                                value={selectedValue}
                                onChange={handleDropdownChange}
                                className="block bg-white text-gray-700 w-full p-2 rounded-lg border border-slate-200"
                            >
                                <option value="" disabled>
                                    Select search type
                                </option>
                                {options.map((opt) => (
                                    <option key={opt.label} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={`flex-1  ${open ? 'max-w-56' : 'min-w-[250px]'} relative`}>
                            <input
                                type="text"
                                placeholder={placeholder}
                                className={`w-full border border-gray-300 text-gray-700 rounded-md px-4 py-2 shadow-sm focus:outline-none focus:ring focus:ring-blue-300 ${isLoading ? "pr-10" : ""
                                    }`}
                                onChange={handleChange}
                                value={value}
                                disabled={isDisabled}
                            />
                            {isLoading && (
                                <div className="absolute inset-y-0 right-3 flex items-center">
                                    <RiLoader4Line className="w-5 h-5 text-gray-500 animate-spin" />
                                </div>
                            )}

                            {isDropdownOpen && (
                                <ul className="absolute w-full max-h-60 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg mt-1 z-50">
                                    {searchResults.length > 0 ? (
                                        searchResults.map((result, idx) => {
                                            let displayText = "";

                                            if (selectedValue === "Account Name") {
                                                displayText = result.account_name;
                                            } else if (selectedValue === "ARN Number") {
                                                displayText = result.arn_no;
                                            } else if (selectedValue === "Vehicle Registration Number") {
                                                displayText = result.Vehicle_Registration_Number;
                                            } else if (selectedValue === "Chassis Number") {
                                                displayText = result.Chassis_number;
                                            }

                                            return (
                                                <li
                                                    key={idx}
                                                    className="p-2 cursor-pointer hover:bg-gray-200"
                                                    onClick={() => handleSuggestionClick(result)}
                                                >
                                                    {displayText}
                                                </li>
                                            );
                                        })
                                    ) : (
                                        <li className="p-2 text-gray-500">No results found</li>
                                    )}

                                </ul>
                            )}
                        </div>

                        <div className="flex-1 min-w-[200px]">
                            <input
                                type="text"
                                placeholder="ARN Number"
                                className="w-full border border-gray-300 text-gray-500 rounded-md px-4 py-2 shadow-sm"
                                value={id}
                                readOnly
                            />
                        </div>
                        <button onClick={handlereset} className="px-3 py-1 bg-gray-200 rounded-md text-gray-600 border">Reset</button>

                    </div>
                </div >
            )}
            <div className="w-full mx-auto p-4 justify-center justify-items-center">
                <div className="flex flex-col gap-8 lg:flex-row">
                    <div className=" relative flex flex-col items-center mt-20">
                        <div className="bg-gradient-to-r from-purple-500 via-blue-600 to-blue-700 rounded-3xl rounded-b-[7rem] p-6 text-white relative w-56">
                            <div className="absolute -top-20 left-1/2 -translate-x-1/2 z-30">
                                <div className="bg-teal-400 text-white px-3 py-1 rounded-t-lg text-sm font-medium shadow">
                                    Parent
                                </div>
                            </div>

                            <div className="absolute -top-14 left-1/2 -translate-x-1/2 z-20">
                                <div className="w-32 h-32 bg-blue-900 rounded-full flex items-center justify-center shadow-lg border-4 border-white/20">
                                    <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center relative">
                                        <img src={parimg} className="h-16" alt="Parent Icon" />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-16 space-y-1 text-left px-2">
                                <div className="flex">
                                    <p className="text-white/80 text-[11px]">Golden ARN :</p>
                                    <p className="font-semibold text-[11px] text-white">
                                        {id}
                                    </p>
                                </div>
                                <div className="flex">
                                    <span className="text-white/80 text-[11px]">Account Name :</span>
                                    <p className="font-semibold text-[11px] text-white">
                                        {accountName}
                                    </p>
                                </div>
                                <div className="flex">
                                    <span className="text-white/80 text-[11px]">KA Code :</span>
                                    <p className="font-semibold text-[11px] text-white">{kacodeparent}</p>
                                </div>
                                <div className="flex">
                                    <span className="text-white/80 text-[11px]">Last Purchase Qnt:</span>
                                    <p className="font-semibold text-[11px] text-white">
                                        {purchasequantity}
                                    </p>
                                </div>
                                <div className="flex">
                                    <span className="text-white/80 text-[11px]">Last Purchase Dt:</span>
                                    <p className="font-semibold text-[11px] text-white">
                                        {purchasedate}
                                    </p>
                                </div>
                                <div className="flex">
                                    <span className="text-white/80 text-[11px]">
                                        Last Purchase Dealership:
                                    </span>
                                    <p className="font-semibold text-[11px] text-white">
                                        {dealershiplastpurchase}
                                    </p>
                                </div>
                            </div>

                            <div className="flex justify-center mt-3">
                                <button
                                    onClick={() => alert(`Selected Parent ARN: ${id}`)}
                                    className=" text-white px-4 py-2 rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 flex items-center gap-2 transition-all duration-200"
                                    title="Click Here"
                                >
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={`w-full lg:${open ? 'w-[500px]' : 'w-[900px]'} mt-3 relative`}>
                        <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-30">
                            <div className="bg-teal-400 text-white px-4 py-1 rounded-md text-sm shadow border border-blue-100">
                                Child
                            </div>
                        </div>

                        <div className="bg-white rounded-lg shadow-md border-2 border-blue-500 relative p-4">
                            <div className="pt-2">
                                <Arntable id={id} />
                            </div>
                        </div>

                        <div className="flex justify-end mt-6">
                            <button
                                onClick={openModal}
                                className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition-colors shadow-sm"
                            >
                                Add ARN
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ArnModal
                isOpen={isModalOpen}
                onClose={closeModal}
                id={id}
            />
        </>
    );
};

export default ArnSearch;
